import { Link } from "react-router-dom";
import "./index.scss";
function Error404() {
  return <div className="Error py-5 text-center h1 d-flex flex-column flex-center">
    صفحه مورد نظر یافت نشد.
    <Link to='/' className='Btn btn btn-primary mt-5'>
      بازگشت به صفحه اصلی
    </Link>
  </div>;
}
function Error403() {
  return <div className="Error">403</div>;
}
function Error500() {
  return <div className="Error">500</div>;
}
const Error = {
  Error404,
  Error403,
  Error500,
};
export default Error;
